import React, { useCallback } from 'react';
import { Upload } from 'lucide-react';

const FileUpload = ({ onFilesSelected }) => {
    const handleDrop = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();

        const files = Array.from(e.dataTransfer.files);
        if (files.length > 0) {
            onFilesSelected(files);
        }
    }, [onFilesSelected]);

    const handleDragOver = useCallback((e) => {
        e.preventDefault();
        e.stopPropagation();
    }, []);

    const handleFileInput = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            onFilesSelected(files);
        }
    };

    return (
        <div
            className="glass-card flex-center"
            style={{
                borderStyle: 'dashed',
                borderWidth: '2px',
                minHeight: '200px',
                flexDirection: 'column',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
            }}
            onDrop={handleDrop}
            onDragOver={handleDragOver}
            onClick={() => document.getElementById('fileInput').click()}
        >
            <input
                type="file"
                id="fileInput"
                multiple
                accept="image/png, image/jpeg, image/svg+xml"
                style={{ display: 'none' }}
                onChange={handleFileInput}
            />
            <div className="flex-center" style={{
                width: '64px',
                height: '64px',
                borderRadius: '50%',
                background: 'rgba(99, 102, 241, 0.1)',
                marginBottom: '1rem',
                color: 'var(--primary)'
            }}>
                <Upload size={32} />
            </div>
            <h3 style={{ marginBottom: '0.5rem' }}>Drop your images here</h3>
            <p style={{ fontSize: '0.875rem' }}>or click to browse (PNG, JPG, SVG)</p>
        </div>
    );
};

export default FileUpload;
